import { AxiosResponse } from "axios";
import { axiosInstance } from "./common";

export enum TenantFeatureFlagKey {
  AI_FEATURES_ENABLED = "AI_FEATURES_ENABLED",
  BOARD_PRESENTATION_ENABLED = "BOARD_PRESENTATION_ENABLED",
  DOCUMENTS_PANEL_ENABLED = "DOCUMENTS_PANEL_ENABLED",
  AI_INSIGHTS_ENABLED= "AI_INSIGHTS_ENABLED",
  FINAL_FIC_V2_ENABLED = "FINAL_FIC_V2_ENABLED",
  REFERRAL_DATE_MAX_LOOKBACK_DAYS = "REFERRAL_DATE_MAX_LOOKBACK_DAYS",
  PLANNED_MAINTAINANCE_DATES = "PLANNED_MAINTAINANCE_DATES",
  REPORTS_POLICY_NORMALIZATION_ENABLED = "REPORTS_POLICY_NORMALIZATION_ENABLED",
  INTERNAL_REPORTS_ENABLED = "INTERNAL_REPORTS_ENABLED",
  LEGAL_TECHNICAL_ANALYSIS_V2_ENABLED = "LEGAL_TECHNICAL_ANALYSIS_V2_ENABLED",
  FRAUD_ELEMENTS_ENABLED = "FRAUD_ELEMENTS_ENABLED",
  GENERATE_FRAUD_ELEMENTS_ENABLED = "GENERATE_FRAUD_ELEMENTS_ENABLED",
  CREDIT_ACCOUNT_STAKEHOLDERS_REVAMP_ENABLED = "CREDIT_ACCOUNT_STAKEHOLDERS_REVAMP_ENABLED",
  ACCOUNT_DETAILS_ENABLED = "ACCOUNT_DETAILS_ENABLED",
  SANCTION_AND_DISBURSEMENT_ENABLED = "SANCTION_AND_DISBURSEMENT_ENABLED",
  STATIC_DASHBOARD_DEMO_ENABLED = "STATIC_DASHBOARD_DEMO_ENABLED",
  INVESTIGATION_REPORT_DOWNLOAD_ENABLED = "INVESTIGATION_REPORT_DOWNLOAD_ENABLED",
  FIC_INCEDENT_PARTICULARS_ENABLED = "FIC_INCEDENT_PARTICULARS_ENABLED",
  OPERATIONAL_CYBER_REVAMP_ENABLED="OPERATIONAL_CYBER_REVAMP_ENABLED",
  IDENTITY_PROFILE_VERIFICATIONS_V2_ENABLED = "IDENTITY_PROFILE_VERIFICATIONS_V2_ENABLED",
  INSPECTIONS_AND_AUDITS_ENABLED = "INSPECTIONS_AND_AUDITS_ENABLED",
}

export interface TenantFeatureFlag {
  ff_key: string;
  ff_value: string;
}

export interface GetFeatureFlagsResponse {
  feature_flags: TenantFeatureFlag[];
}

const FeatureFlagsAPI = {
  get: async (): Promise<TenantFeatureFlag[]> => {
    try {
      const response: AxiosResponse<GetFeatureFlagsResponse> =
        await axiosInstance.get("/v1/feature-flags");

      return response.data.feature_flags;
    } catch (error) {
      console.error(error);
      return [];
    }
  },
};

export default FeatureFlagsAPI;